import { useEffect } from 'react';

import {
  ApiABExperimentBucketForId,
  ApiABExperimentId,
} from 'api/types/ApiABExperiment';

import { useSetABExperimentBucket } from './useSetABExperimentBucket';
import { useUserEnvironmentABExperimentBucket } from './useUserEnvironmentABExperimentBucket';

type Props<TExperimentId extends ApiABExperimentId> = {
  experimentId: TExperimentId;
  defaultBucket: ApiABExperimentBucketForId<TExperimentId>;
  initializeWithDefault?: boolean;
};

export function useABExperimentBucket<TExperimentId extends ApiABExperimentId>({
  experimentId,
  defaultBucket,
  initializeWithDefault,
}: Props<TExperimentId>):
  | ApiABExperimentBucketForId<TExperimentId>
  | undefined {
  const { loaded, bucket } =
    useUserEnvironmentABExperimentBucket<TExperimentId>(experimentId);
  const setABExperimentBucket = useSetABExperimentBucket(experimentId);

  useEffect(() => {
    if (loaded && !bucket) setABExperimentBucket();
  }, [loaded, bucket, setABExperimentBucket]);

  if (bucket) return bucket;

  // There's a user, but the user doesn't have a bucket set yet.
  // Fallback to the default bucket
  if (loaded) return defaultBucket;

  // If `initializeWithDefault` we want to fallback even if there's no user
  return initializeWithDefault ? defaultBucket : undefined;
}
